import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const PaymentTerms = ({ paymentTerms }) => {
    return (
        <Block isRender={paymentTerms}>
            <SectionCard icon="mdi:cash-refund" titleKey="payment-terms-header">
                <div className="refund-policy-content">
                    <p>{paymentTerms}</p>
                </div>
            </SectionCard>
        </Block>
    )
}

export default PaymentTerms

